// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"b0befbcc","419":"504c329f","458":"b507c1fe","459":"976c5199","774":"69504864","858":"7abd97b9"}[chunkId] + ".chunk.js";
};